export const CP_SHARE_PRODUCT_DETAIL = 'CP_SHARE_PRODUCT_DETAIL';

export const CP_SHARE_PRODUCT_DETAIL_SUCCESS = 'CP_SHARE_PRODUCT_DETAIL_SUCCESS';

export const CP_SHARE_PRODUCT_DETAIL_FAILED = 'CP_SHARE_PRODUCT_DETAIL_FAILED';